// material-ui
import { styled } from '@mui/material/styles';
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import { Box } from '@mui/material';


// loader style
const LoaderWrapper = styled('div')(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 2001,
  width: '100%',
  '& > * + *': {
    marginTop: theme.spacing(2)
  }
}));

const CircularLoaderWrapper = styled('div')(({ theme }) => ({
  position: 'fixed',
  // top: 0,
  // left: 0,
  zIndex: 2001,
  width: '100%',
  '& > * + *': {
    marginTop: theme.spacing(5),
    // justifyContent: "center",
    // alignItems: "center"
  }
}));
// ==============================|| Circular Loader ||============================== //

export interface CircularLoaderProps extends CircularProgressProps {}

export const CircularLoaderProgress = () => (
  <CircularLoaderWrapper>
    <CircularProgress color="primary" />
    <Box component="h4">HotelPro</Box>
  </CircularLoaderWrapper>
);

// ==============================|| Linear Loader ||============================== //

export interface LinearLoaderProps extends LinearProgressProps {}

export const LinearLoaderProgress = () => (
  <LoaderWrapper>
    <LinearProgress color="info" />
    <Box component="h4">HotelPro</Box>
  </LoaderWrapper>
);

